import { createGlobalStyle } from 'styled-components'

const OpenProps = createGlobalStyle`
  :root {
    --font-sans: system-ui,-apple-system,Segoe UI,Roboto,Ubuntu,Cantarell,Noto Sans,sans-serif;
    --font-serif: ui-serif,serif;
    --font-mono: Dank Mono,Operator Mono,Inconsolata,Fira Mono,ui-monospace,SF Mono,Monaco,Droid Sans Mono,Source Code Pro,monospace;
    --font-weight-1: 100;
    --font-weight-2: 200;
    --font-weight-3: 300;
    --font-weight-4: 400;
    --font-weight-5: 500;
    --font-weight-6: 600;
    --font-weight-7: 700;
    --font-weight-8: 800;
    --font-weight-9: 900;
    --font-lineheight-00: 1.4rem;
    --font-lineheight-0: 1.6rem;
    --font-lineheight-1: 2rem;
    --font-lineheight-2: 2.4rem;
    --font-lineheight-3: 2.8rem;
    --font-lineheight-4: 2.8rem;
    --font-lineheight-5: 3.2rem;
    --font-lineheight-6: 3.6rem;
    --font-lineheight-7: 4rem;
    --font-lineheight-8: 1;
    --font-lineheight-9: 1;
    --font-lineheight-10: 1;
    --font-lineheight-11: 1;
    --font-lineheight-12: 1;
    --font-letterspacing-0: -.05em;
    --font-letterspacing-1: .025em;
    --font-letterspacing-2: .050em;
    --font-letterspacing-3: .075em;
    --font-letterspacing-4: .150em;
    --font-letterspacing-5: .500em;
    --font-letterspacing-6: .750em;
    --font-letterspacing-7: 1em;
    --font-size-00: 0.8rem;
    --font-size-0: 1.2rem;
    --font-size-1: 1.4rem;
    --font-size-2: 1.6rem;
    --font-size-3: 1.8rem;
    --font-size-4: 2rem;
    --font-size-5: 2.4rem;
    --font-size-6: 3rem;
    --font-size-7: 3.6rem;
    --font-size-8: 4.8rem;
    --font-size-9: 6rem;
    --font-size-10: 7.2rem;
    --font-size-11: 9.6rem;
    --font-size-12: 12.8rem;
    --size-unit: 0.4rem;
    --size-000: calc(var(--size-unit) * 0.25);
    --size-00: calc(var(--size-unit) * 0.5);
    --size-1: calc(var(--size-unit) * 1);
    --size-2: calc(var(--size-unit) * 2);
    --size-3: calc(var(--size-unit) * 3);
    --size-4: calc(var(--size-unit) * 4);
    --size-5: calc(var(--size-unit) * 5);
    --size-6: calc(var(--size-unit) * 6);
    --size-7: calc(var(--size-unit) * 7);
    --size-8: calc(var(--size-unit) * 8);
    --size-9: calc(var(--size-unit) * 9);
    --size-10: calc(var(--size-unit) * 10);
    --size-11: calc(var(--size-unit) * 11);
    --size-12: calc(var(--size-unit) * 12);
    --size-13: calc(var(--size-unit) * 13);
    --size-14: calc(var(--size-unit) * 14);
    --size-15: calc(var(--size-unit) * 15);
    --size-16: calc(var(--size-unit) * 16);
    --size-xxs: 240px;
    --size-xs: 360px;
    --size-sm: 480px;
    --size-md: 768px;
    --size-lg: 1024px;
    --size-xl: 1440px;
    --size-xxl: 1920px;
    --layer-1: 1;
    --layer-2: 2;
    --layer-3: 3;
    --layer-4: 4;
    --layer-5: 5;
    --layer-important: 2147483647;
    --shadow-color: 189 16% 6%;
    --shadow-strength: 10%;
    --shadow-1: 0 1px 2px -1px hsl(var(--shadow-color) / calc(var(--shadow-strength) + 9%));
    --shadow-2: 
      0 3px 5px -2px hsl(var(--shadow-color) / calc(var(--shadow-strength) + 3%)),
      0 7px 14px -5px hsl(var(--shadow-color) / calc(var(--shadow-strength) + 5%));
    --shadow-3: 
      0 -1px 3px 0 hsl(var(--shadow-color) / calc(var(--shadow-strength) + 2%)),
      0 1px 2px -5px hsl(var(--shadow-color) / calc(var(--shadow-strength) + 2%)),
      0 2px 5px -5px hsl(var(--shadow-color) / calc(var(--shadow-strength) + 4%)),
      0 4px 12px -5px hsl(var(--shadow-color) / calc(var(--shadow-strength) + 5%)),
      0 12px 15px -5px hsl(var(--shadow-color) / calc(var(--shadow-strength) + 7%));
    --shadow-4: 
      0 -2px 5px 0 hsl(var(--shadow-color) / calc(var(--shadow-strength) + 2%)),
      0 1px 1px -2px hsl(var(--shadow-color) / calc(var(--shadow-strength) + 3%)),
      0 2px 2px -2px hsl(var(--shadow-color) / calc(var(--shadow-strength) + 3%)),
      0 5px 5px -2px hsl(var(--shadow-color) / calc(var(--shadow-strength) + 4%)),
      0 9px 9px -2px hsl(var(--shadow-color) / calc(var(--shadow-strength) + 5%)),
      0 16px 16px -2px hsl(var(--shadow-color) / calc(var(--shadow-strength) + 6%));
    --shadow-5: 
      0 -1px 2px 0 hsl(var(--shadow-color) / calc(var(--shadow-strength) + 2%)),
      0 2px 1px -2px hsl(var(--shadow-color) / calc(var(--shadow-strength) + 3%)),
      0 5px 5px -2px hsl(var(--shadow-color) / calc(var(--shadow-strength) + 3%)),
      0 10px 10px -2px hsl(var(--shadow-color) / calc(var(--shadow-strength) + 4%)),
      0 20px 20px -2px hsl(var(--shadow-color) / calc(var(--shadow-strength) + 5%)),
      0 40px 40px -2px hsl(var(--shadow-color) / calc(var(--shadow-strength) + 7%));
    --shadow-6: 
      0 -1px 2px 0 hsl(var(--shadow-color) / calc(var(--shadow-strength) + 2%)),
      0 3px 2px -2px hsl(var(--shadow-color) / calc(var(--shadow-strength) + 3%)),
      0 7px 5px -2px hsl(var(--shadow-color) / calc(var(--shadow-strength) + 3%)),
      0 12px 10px -2px hsl(var(--shadow-color) / calc(var(--shadow-strength) + 4%)),
      0 22px 18px -2px hsl(var(--shadow-color) / calc(var(--shadow-strength) + 5%)),
      0 41px 33px -2px hsl(var(--shadow-color) / calc(var(--shadow-strength) + 6%)),
      0 100px 80px -2px hsl(var(--shadow-color) / calc(var(--shadow-strength) + 7%));
    --inner-shadow-0: inset 0 0 0 1px hsl(var(--shadow-color) / calc(var(--shadow-strength) + 9%));
    --inner-shadow-1: inset 0 1px 2px 0 hsl(var(--shadow-color) / calc(var(--shadow-strength) + 9%));
    --inner-shadow-2: inset 0 1px 4px 0 hsl(var(--shadow-color) / calc(var(--shadow-strength) + 9%));
    --inner-shadow-3: inset 0 2px 8px 0 hsl(var(--shadow-color) / calc(var(--shadow-strength) + 9%));
    --inner-shadow-4: inset 0 2px 14px 0 hsl(var(--shadow-color) / calc(var(--shadow-strength) + 9%));
    --ratio-square: 1;
    --ratio-landscape: 4/3;
    --ratio-portrait: 3/4;
    --ratio-widescreen: 16/9;
    --ratio-ultrawide: 18/5;
    --ratio-golden: 1.6180/1;
    --gray-0: #f8f9fa;
    --gray-1: #f1f3f5;
    --gray-2: #e9ecef;
    --gray-3: #dee2e6;
    --gray-4: #ced4da;
    --gray-5: #adb5bd;
    --gray-6: #868e96;
    --gray-7: #495057;
    --gray-8: #343a40;
    --gray-9: #212529
    --gray-0-hsl: 210 17% 98%;
    --gray-1-hsl: 210 17% 95%;
    --gray-2-hsl: 210 16% 93%;
    --gray-3-hsl: 210 14% 89%;
    --gray-4-hsl: 210 14% 83%;
    --gray-5-hsl: 210 11% 71%;
    --gray-6-hsl: 210 7% 56%;
    --gray-7-hsl: 210 9% 31%;
    --gray-8-hsl: 210 10% 23%;
    --gray-9-hsl: 210 11% 15%;
    --border-size-1: 1px;
    --border-size-2: 2px;
    --border-size-3: 5px;
    --border-size-4: 10px;
    --border-size-5: 25px;
    --radius-1: 2px;
    --radius-2: 5px;
    --radius-3: 1rem;
    --radius-4: 2rem;
    --radius-5: 4rem;
    --radius-6: 8rem;
    --radius-round: 1e5px;
  }
`

export default OpenProps
